module.exports = __webpack_public_path__ + "static/media/chevron-right.0beae5d1.svg";